let currentContact;
// Function to set the contact data
export function setContactData(contact) {
    currentContact = contact;
}
// Function to get the contact data
export function getContactData() {
    return currentContact;
}
